<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="pb-5">
        <v-col
          cols="12"
          sm="6"
          :md="$canRoute('trading-account-reg-tab') !== 1 ? 8 : 4"
          :lg="$canRoute('trading-account-reg-tab') !== 1 ? 8 : 4"
        >
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search anything here ..."
            single-line
            solo
            hide-details
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="4">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="dateRange"
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedDatesText"
                prepend-icon="mdi-calendar"
                append-icon="mdi-chevron-down"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                class="custom-select"
                label="Date Range"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDates"
              class="custom-date-picker"
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col
          v-if="$canRoute('trading-account-reg-tab') === 1"
          cols="6"
          sm="6"
          md="2"
          lg="2"
        >
          <ul>
            <li>
              <v-dialog
                transition="scale-transition"
                origin="center center"
                max-width="460"
                v-model="dialogDeposit"
                content-class="deposit-withdraw-popup marketingPopup"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    tile
                    elevation="0"
                    class="text-capitalize"
                    color="#039de9"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon> mdi mdi-plus </v-icon>
                    New Live Account
                  </v-btn>
                </template>
                <!-- Dialog content goes here -->
                <v-card
                  class="rounded-0 pa-7"
                  :class="
                    $vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  "
                >
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Trading Account
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Create A New Trading Account For This User
                  </v-card-subtitle>
                  <v-card
                    class="deposit-form px-3 py-4"
                    :class="
                      $vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Account Type</legend>
                          <v-select
                            v-model="trading_account_type_id"
                            solo
                            :items="accountTypeOptions"
                            item-text="displayText"
                            item-value="id"
                            append-icon="mdi-chevron-down"
                            label="Click to select"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Leverage</legend>
                          <v-select
                            solo
                            v-model="leverage"
                            :items="leverageOptions"
                            item-text="displayText"
                            item-value="value"
                            append-icon="mdi-chevron-down"
                            label="Select One"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>

                      <v-col cols="12">
                        <fieldset>
                          <legend>Password</legend>
                          <v-text-field
                            label="Write New Password"
                            v-model="password"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'"
                            counter
                            @click:append="show1 = !show1"
                            single-line
                            solo
                            hide-details
                            class="custom-select"
                          ></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn
                          tile
                          :loading="loading"
                          :disabled="loading"
                          @click="createTradingAccount"
                          elevation="0"
                          class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain"
                          >Create</v-btn
                        >
                        <v-btn
                          tile
                          color="#FF567F"
                          @click="dialogDeposit = false"
                          elevation="0"
                          class="text-capitalize btn-account px-sm-8"
                          >Cancel</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>

        <v-col
          v-if="$canRoute('trading-account-reg-tab') === 1"
          cols="6"
          sm="6"
          md="2"
          lg="2"
        >
          <ul>
            <li>
              <v-dialog
                transition="scale-transition"
                origin="center center"
                max-width="460"
                v-model="dialogUpdate"
                content-class="deposit-withdraw-popup marketingPopup"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    tile
                    elevation="0"
                    class="text-capitalize"
                    color="#039de9"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <!-- <v-icon> mdi mdi-plus </v-icon> -->
                    Update Mt5 Acc.
                  </v-btn>
                </template>
                <!-- Dialog content goes here -->
                <v-card
                  class="rounded-0 pa-7"
                  :class="
                    $vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  "
                >
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Update MT5 Account Information
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Update The MT5 Account Information For This User
                  </v-card-subtitle>
                  <v-card
                    class="deposit-form px-3 py-4"
                    :class="
                      $vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Trading Account</legend>
                          <v-select
                            v-model="tradingAccount"
                            solo
                            :items="tradingAccounts"
                            item-text="displayText"
                            item-value="id"
                            append-icon="mdi-chevron-down"
                            label="Select Trading Account"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Change Operation</legend>
                          <v-select
                            v-model="selectedChangeOption"
                            solo
                            :items="changeOptions"
                            item-text="text"
                            item-value="value"
                            append-icon="mdi-chevron-down"
                            label="Select One Option"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" v-if="selectedChangeOption === '1'">
                        <fieldset>
                          <legend>New Account Type</legend>
                          <v-select
                            v-model="trading_account_type_id"
                            solo
                            :items="accountTypeOptions"
                            item-text="displayText"
                            item-value="id"
                            append-icon="mdi-chevron-down"
                            label="Select New Acc. Type"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" v-if="selectedChangeOption === '2'">
                        <fieldset>
                          <legend>New Leverage</legend>
                          <v-select
                            solo
                            v-model="leverage"
                            :items="leverageOptions"
                            item-text="displayText"
                            item-value="value"
                            append-icon="mdi-chevron-down"
                            label="Select New Leverage"
                            class="custom-select"
                            hide-details
                          ></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" v-if="selectedChangeOption === '3'">
                        <fieldset class="mb-0">
                          <legend>New Master Password</legend>
                          <v-text-field
                            label="Write New Master Password Here"
                            v-model="newPassword"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            counter
                            @click:append="show = !show"
                            single-line
                            solo
                            hide-details
                            class="custom-select"
                          ></v-text-field>
                        </fieldset>
                        <p
                          class="text-small text--ash mb-2"
                          style="font-size: 0.75em; font-style: italic"
                        >
                          Please give at least 8 characters including: 1
                          uppercase, 1 lowercase, 1 digit and 1 special
                          character
                        </p>
                        <!-- <fieldset>
                <legend>New Master Password</legend>
                <v-text-field v-model="newPassword" label="Write New Master Password Here" single-line solo hide-details
                  class="custom-select"></v-text-field>
              </fieldset> -->
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn
                          tile
                          :loading="loading"
                          :disabled="isDisabled"
                          @click="updateMT5Option"
                          elevation="0"
                          class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain"
                          >Update</v-btn
                        >
                        <v-btn
                          tile
                          color="#FF567F"
                          @click="cancelUpdate"
                          elevation="0"
                          class="text-capitalize btn-account px-sm-8"
                          >Cancel</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      class="pa-0 rounded-0 elevation-0"
      :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
    >
      <v-sheet
        class="transactionTable depositTabTable"
        :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
      >
        <v-data-table
          :headers="headers"
          :search="search"
          :items-per-page="5"
          :items="userTradingAccounts"
        >
          <template v-slot:item.SerialNumber="{ index, item }">
            {{ index + 1 }}
          </template>
          <template v-slot:item.trading_account_no="{ index, item }">
            <span>
              {{ item.trading_account_no }} ({{ item.account_type_display }})
              <span
                v-if="item.trader_type === 2"
                style="color: #ed9831; font-weight: 600"
                >- Investor</span
              >
            </span>
          </template>
          <!-- <template v-slot:item.trader_type="{ item }">
            <span>
              {{ item.trader_type === 2 ? "Investor" : " " }}
            </span>
          </template> -->

          <template v-slot:item.created_at="{ index, item }">
            {{ formatMySQLDate(item?.created_at) || "N/A" }}
          </template>
          <template v-slot:item.deposit="{ index, item }">
            {{ formattedAllNumber(item.deposit) }}
          </template>
          <template v-slot:item.USD="{ index, item }"> USD </template>
          <template v-slot:item.withdraw="{ index, item }">
            {{ formattedAllNumber(item.withdraw) }}
          </template>
          <template v-slot:item.Profit="{ index, item }">
            {{ formattedAllNumber(item.Profit) }}
          </template>
          <template v-slot:item.creditIn="{ index, item }">
            {{ formattedAllNumber(item.creditIn) }}
          </template>
          <template v-slot:item.creditOut="{ index, item }">
            {{ formattedAllNumber(item.creditOut) }}
          </template>
          <template v-slot:item.Balance="{ index, item }">
            {{ formattedAllNumber(item.Balance) }}
          </template>
          <template v-slot:item.Equity="{ index, item }">
            {{ formattedAllNumber(item.Equity) }}
          </template>
          <template v-slot:item.MarginFree="{ index, item }">
            {{ formattedAllNumber(item.MarginFree) }}
          </template>
          <template v-slot:item.admin_name="{ item }">
            {{ item.admin_name || "N/A" }}
          </template>
          <!-- <template v-slot:item.ActionType="{ item }">
            <div class="trade-dropdown">
              <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on"
                    icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card class="dropdown-menu-card" tile flat>
                  <v-list flat elevation="0" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-1'">
                    <v-list-item-group>
                      <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                        <v-list-item-content>
                          <router-link v-text="item.text" class="text-decoration-none" router
                            :to="item.link"></router-link>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </template> -->
        </v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  REGISTERUSERDETAILS__ACTIONS,
  COMMISSIONSETTINGS__ACTIONS,
  LEVERAGE__ACTIONS,
} from "@/store/action-types";
import { formatNumber } from "@/_helpers/formatNumber";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      loading: false,
      dialogDeposit: false,
      dialogUpdate: false,
      modal: false,
      search: "",
      show1: false,
      password: "",
      show: false,
      trading_account_type_id: "",
      leverage: "",
      newPassword: "",
      trader_type: "",
      client_account_id: null,
      tradingAccount: null,
      selectedDates: [],
      selectedDatesText: null,
      selectedChangeOption: null,
      dateRange: [],
      items: [
        { text: "Change Account Type", link: "/" },
        { text: "Deposit Funds", link: "/" },
        { text: "Withdraw Funds", link: "/" },
        { text: "Internal Transfer", link: "/" },
        { text: "Credit In / Out", link: "/" },
        { text: "Change MT5 Password", link: "/" },
        { text: "Change Leverage", link: "/" },
      ],
      changeOptions: [
        { text: "Change Account Type", value: "1" },
        { text: "Change Leverage", value: "2" },
        { text: "Change Master Password", value: "3" },
      ],
      headers: [
        { text: "SL.", align: "start", class: "pl-5", value: "SerialNumber" },
        { text: "MT5 Account No.", value: "trading_account_no" },
        { text: "Reg. Date & Time", value: "created_at" },
        { text: "Leverage", value: "leverage" },
        // { text: "Trader Type", value: "trader_type" },
        // { text: "Currency", value: "USD" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdraw", value: "withdraw" },
        { text: "Bonus in", value: "creditIn" },
        { text: "Bonus Out", value: "creditOut" },
        { text: "Profit", value: "Profit" },
        { text: "Balance", value: "Balance" },
        { text: "Equity", value: "Equity" },
        { text: "Free Margin", value: "MarginFree" },
        { text: "Action By", value: "admin_name" },
      ],
    };
  },
  computed: {
    ...mapState("reguserdetails", ["userTradingAccounts"]),
    ...mapState("admins", ["loggedAdmin"]),
    ...mapState("commissionsettings", ["accountTypes"]),
    ...mapState("leverage", ["leverages"]),

    selectedDatesText() {
      return this.dateRange.join(" ~ ");
    },

    tradingAccounts() {
      return this.userTradingAccounts?.map((item) => ({
        id: item.trading_account_no,
        displayText: `${item.trading_account_no} (${item.account_type_display} - 1:${item.leverage})`,
      }));
    },

    accountTypeOptions() {
      return this.accountTypes?.map((item) => ({
        id: item.id,
        displayText: `${item.account_type_display} (${item.account_type_real})`,
      }));
    },

    leverageOptions() {
      return this.leverages?.map((item) => ({
        id: item.id,
        value: item.leverage,
        displayText: `1:${item.leverage}`,
      }));
    },

    isDisabled() {
      if (this.loading === true) return true;

      // Only validate password when changing master password (option '3')
      if (this.selectedChangeOption === "3") {
        if (
          !this.newPassword ||
          this.newPassword.length < 8 ||
          !/[a-z]/.test(this.newPassword) ||
          !/[A-Z]/.test(this.newPassword) ||
          !/[0-9]/.test(this.newPassword) ||
          !/[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)
        ) {
          return true;
        }
        return false;
      }
      // For other options, just check loading
      return this.loading;
    },
  },

  methods: {
    formatMySQLDate,
    ...mapActions("reguserdetails", [
      REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS,
      REGISTERUSERDETAILS__ACTIONS.CREATELIVEACCOUNT,
      REGISTERUSERDETAILS__ACTIONS.UPDATEMT5ACCOUNT,
    ]),

    ...mapActions("leverage", [LEVERAGE__ACTIONS.LEVERAGE]),
    ...mapActions("commissionsettings", [
      COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS,
    ]),

    async updateMT5Option() {
      this.loading = true;
      try {
        const parameter = {
          client_account_id: this.client_account_id,
          trading_account_no: this.tradingAccount,
          trading_account_type_id: this.trading_account_type_id,
          leverage: this.leverage,
          newPassword: this.newPassword,
        };
        await this[REGISTERUSERDETAILS__ACTIONS.UPDATEMT5ACCOUNT](parameter);

        this.tradingAccount = null;
        this.trading_account_type_id = null;
        this.leverage = null;
        this.newPassword = null;
        this.selectedChangeOption = null;

        await this[REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS]({
          client_account_id: this.client_account_id,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.dialogUpdate = false;
      }
    },

    cancelUpdate() {
      this.dialogUpdate = false;
      this.tradingAccount = null;
      this.trading_account_type_id = null;
      this.leverage = null;
      this.newPassword = null;
      this.password = "";
      this.selectedChangeOption = null;
    },

    async createTradingAccount() {
      this.loading = true;
      try {
        const parameter = {
          client_account_id: this.client_account_id,
          trading_account_type_id: this.trading_account_type_id,
          leverage: this.leverage,
          AccPassword: this.password
        };
        await this[REGISTERUSERDETAILS__ACTIONS.CREATELIVEACCOUNT](parameter);
        this.trading_account_type_id = null;
        this.leverage = null;
        this.password = "";
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.dialogDeposit = false;
      }
    },

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        client_account_id: this.client_account_id,
        duration: `${startDate.toISOString().split("T")[0]}to${
          endDate.toISOString().split("T")[0]
        }`,
      };

      this[REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },
  async mounted() {
    this.client_account_id = this.$route.params.id;
    this[REGISTERUSERDETAILS__ACTIONS.USERTRADINGACCOUNTS]({
      client_account_id: this.$route.params.id,
    });
    this[COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS]();
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },

  async created() {
    await this[LEVERAGE__ACTIONS.LEVERAGE]();
  },
};
</script>
